<template>
  <div
    data-component="base-item-actions-inline"
    :class="{ 'is-disabled': isDisabled }"
  >
    <div
      v-if="!showActionIcons && actions.length"
      class="actions"
    >
      <div
        v-for="action of actions"
        :key="action.key"
        :data-button="action.key"
        @click="onActionClick(action.key)"
      >
        {{ action.label }}
      </div>
    </div>

    <div
      v-if="showActionIcons && actions.length"
      class="action-icons"
    >
      <base-icon-button
        v-for="action of actions"
        :key="action.key"
        :data-button="action.key"
        :icon="action.icon"
        :color="action.color || 'primary'"
        :is-disabled="isDisabled"
        @click="onActionClick(action.key)"
      />
    </div>

    <div
      v-if="description && !showActionIcons"
      class="description"
    >
      {{ description }}
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api';

import BaseIconButton from './BaseIconButton.vue';
import { ITEM_ACTIONS_PROP } from '../../constants';

export default defineComponent({
  name: 'BaseItemActionsInline',
  components: { BaseIconButton },
  props: {
    description: {
      type: String,
      default: '',
    },
    actions: ITEM_ACTIONS_PROP,
    showActionIcons: Boolean,
    isDisabled: Boolean,
  },
  emits: ['action-click'],
  methods: {
    onActionClick(key: string) {
      if (!this.isDisabled) {
        this.$emit('action-click', key);
      }
    },
  },
});
</script>

<style lang="scss" scoped>
@use '@/styles' as *;

[data-component='base-item-actions-inline'] {
  display: inline-flex;
  flex-direction: column;

  &.is-disabled {
    .actions [data-button],
    .actions [data-button]:hover,
    .description {
      color: var(--or-c-disabled);
      cursor: auto;
    }
  }

  .actions {
    display: flex;
    justify-content: flex-end;
    gap: var(--s-4);

    [data-button] {
      @include text-overflow;

      color: var(--or-c-primary);
      font-weight: var(--fw-1);
      cursor: pointer;

      &:hover {
        color: var(--or-c-primary-hover);
      }
    }
  }

  .action-icons {
    display: flex;
    align-items: center;
    height: 100%;
    gap: var(--s-4);
  }

  .description {
    @include text-overflow;

    font-size: var(--fs-0);
    line-height: 1.5;
    color: var(--or-c-outline);
    text-align: right;
  }
}
</style>
